export const depthToFullTitleDoubleElim = (
  depth: number,
  maxDepth: number,
  isLower: boolean,
  hasMultipleFinals: boolean
) => {
  if (depth === 0) {
    return "Grand Final";
  }

  const roundTitle = depthToFullTitleSingleElim(
    depth,
    maxDepth,
    hasMultipleFinals
  );
  return `${isLower ? "Lower " : "Upper "} ${roundTitle}`;
};

export const depthToFullTitleSingleElim = (
  depth: number,
  maxDepth: number,
  hasMultipleFinals: boolean
) => {
  switch (depth) {
    case 1:
      return `Final${hasMultipleFinals ? "s" : ""}`;
    case 2:
      return "Semi-finals";
    case 3:
      return "Quarter-finals";
    default:
      return `Round ${maxDepth - depth + 1}`;
  }
};

export const depthToShorterTitleDoubleElim = (
  depth: number,
  maxDepth: number,
  isLower: boolean
) => {
  if (depth === 0) {
    return "Grand Final";
  }

  const roundTitle = depthToShorterTitleSingleElim(depth, maxDepth);
  return `${isLower ? "Lower " : "Upper "} ${roundTitle}`;
};

export const depthToShorterTitleSingleElim = (
  depth: number,
  maxDepth: number
) => {
  switch (depth) {
    case 1:
      return "Final";
    case 2:
      return "SF";
    case 3:
      return "QF";
    default:
      return `Round ${maxDepth - depth + 1}`;
  }
};

export const depthToShortestTitleDoubleElim = (
  depth: number,
  maxDepth: number,
  isLower: boolean
) => {
  if (depth === 0) {
    return "GF";
  }

  const roundTitle = depthToShortestTitleSingleElim(depth, maxDepth);
  return `${isLower ? "L" : "U"}${roundTitle}`;
};

export const depthToShortestTitleSingleElim = (
  depth: number,
  maxDepth: number
) => {
  switch (depth) {
    case 1:
      return "F";
    case 2:
      return "SF";
    case 3:
      return "QF";
    default:
      return `R${maxDepth - depth + 1}`;
  }
};
